// import  React from 'react'
// import { Card, Row, Col, Collapse } from 'antd'
// import { DisplayDate } from '../../../components/_utils/appUtils'
// import whiteImage from '../../../assets/icons/white-circle.png'
// import greenImage from '../../../assets/icons/green-circle.png'
// import defaultImage from '../../../assets/icons/default-circle.png'
//
// const { Panel } = Collapse
//
// const AbstractStatusList = [
//   { status: 'Submitted Abstract', label: 'Submitted', key: 'createdAt' },
//   { status: 'Abstract Under Process', label: 'Under Process', key: 'processPayment' },
//   // { status: 'Under Review', label: 'Under Review', key: 'reviewDate' },
//   { status: 'Abstract Under Review', label: 'Under Review', key: 'reviewDate',key1: 'assignedDate' },
//   { status: 'Approved', label: 'Approved', key: 'approvedDate' },
//   { status: 'Processed', label: 'Processed', key: 'statusUpdateDate' },
//   { status: 'Deleted', label: 'Deleted', key: 'deletedDate' },
//   { status: 'Withdrawn', label: 'Withdrawn', key: 'deletedDate' },
// ]
//
// const AbstractStatus = (props) => {
//   let { abstract } = props
//   let { status } = abstract
//   const currentStatusIndex = AbstractStatusList.findIndex(s => s.status === status);
//
//   return (
//     <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
//       <Panel header="Abstract Status" key="1">
//         <Row gutter={8} className={'statusRow'}>
//           {AbstractStatusList.map((item, index) => {
//             let dateValue = abstract[item.key]
//
//             let isActive = index === currentStatusIndex;
//             let isCompleted = !!dateValue || index < currentStatusIndex;
//
//             return (
//               <Col span={4} key={index} className={'statusColumn'}>
//                 <Card className={`box ${isActive ? 'active' : ''}`}>
//                   <div className={'status'}>{item.label}</div>
//                   <div className={'iconDiv'}>
//                     <img
//                       src={isActive ? whiteImage : (isCompleted ? greenImage : defaultImage)}
//                       alt={item.status}
//                     />
//                   </div>
//                   <div className={'date'}>
//                     {DisplayDate(dateValue)}
//                   </div>
//                 </Card>
//               </Col>
//             )
//           })}
//         </Row>
//       </Panel>
//     </Collapse>
//   )
// }
//
// export default AbstractStatus
import React from 'react';
import { Card, Row, Col, Collapse } from 'antd';
import { DisplayDate } from '../../../components/_utils/appUtils';
import whiteImage from '../../../assets/icons/white-circle.png';
import greenImage from '../../../assets/icons/green-circle.png';
import defaultImage from '../../../assets/icons/default-circle.png';

const { Panel } = Collapse;

const AbstractStatusList = [
  { status: 'Submitted Abstract', label: 'Submitted', key: 'createdAt' },
  { status: 'Abstract Under Process', label: 'Under Process', key: 'processPayment' },
  { status: 'Abstract Under Review', label: 'Under Review', key: 'selectedReviewer', key1: 'assignedDate' },
  { status: 'Reviewed Comments', label: 'Reviewed Manuscript', key: 'underReviewDetails', key1: 'receiveDate' },
  { status: 'Comments To Author', label: 'Comments To Author', key: 'sendToAuthorDate' },
  { status: 'Revised Article', label: 'Revised Manuscript', key: 'revisedArticleDate' },
  { status: 'Approved', label: 'Approved', key: 'approvedDate' },
  { status: 'Processed', label: 'Processed', key: 'statusUpdateDate' },
  { status: 'Deleted', label: 'Deleted', key: 'deletedDate' },
  { status: 'Withdrawn', label: 'Withdrawn', key: 'deletedDate' },
];

const AbstractStatus = (props) => {
  let { abstract } = props;
  let { status } = abstract;
  const currentStatusIndex = AbstractStatusList.findIndex(s => s.status === status);

  let getDateFxn = (item) => {
    if (item.key === 'selectedReviewer') {
      let reviewers = abstract.selectedReviewer;
      return (reviewers && reviewers.length > 0) ? reviewers[0][item.key1] : null;
    }
    if (item.key1) {
      return abstract[item.key] ? abstract[item.key][item.key1] : null;
    }
    return abstract[item.key] ? abstract[item.key] : null;
  };

  return (
    <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
      <Panel header="Abstract Status" key="1">
        <Row gutter={8} className={'statusRow'}>
          {AbstractStatusList.map((item, index) => {
            // FIX: Use the helper here instead of direct access
            let dateValue = getDateFxn(item);

            let isActive = index === currentStatusIndex;
            let isCompleted = !!dateValue || index < currentStatusIndex;

            return (
              <Col span={4} key={index} className={'statusColumn'}>
                <Card className={`box ${isActive ? 'active' : ''}`}>
                  <div className={'status'}>{item.label}</div>
                  <div className={'iconDiv'}>
                    <img
                      src={isActive ? whiteImage : (isCompleted ? greenImage : defaultImage)}
                      alt={item.status}
                    />
                  </div>
                  <div className={'date'}>
                    {DisplayDate(dateValue)}
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Panel>
    </Collapse>
  );
};

export default AbstractStatus;
